import {times} from 'ramda';

/**
 * Splits items into `columnCount` columns filled top-to-bottom, then left-to-right.
 *
 * Each column gets `floor(length / columnCount)` items and the remainder goes to the
 * leading columns, one extra item each. With three columns, four items give [2, 1, 1]
 * and eight items give [3, 3, 2].
 *
 * Trailing columns are empty when there are fewer items than columns.
 */
export function distributeIntoColumns<T>(items: T[], columnCount: number): T[][] {
  if (columnCount < 1) {
    return [];
  }

  const baseColumnSize = Math.floor(items.length / columnCount);
  const columnsWithExtraItem = items.length % columnCount;

  return times((columnIndex) => {
    const extraItem = columnIndex < columnsWithExtraItem ? 1 : 0;
    // Items consumed by the preceding columns.
    const start = baseColumnSize * columnIndex + Math.min(columnIndex, columnsWithExtraItem);

    return items.slice(start, start + baseColumnSize + extraItem);
  }, columnCount);
}
